/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import React from 'react';

import { Styled } from './';
import { ServicePlanDetailsProposalEMEAProps } from './ITeroProposal.types';
import { useI18n } from 'contexts/i18n';

const ServicePlanDetailsProposalEMEA = ({
  isMultipleScannerSubscriptions,
  currentProposal,
}: ServicePlanDetailsProposalEMEAProps) => {
  const i18n = useI18n();
  return (
    <>
      <Styled.SummaryTitle>
        {i18n['Service Plan Details* - EMEA']}
      </Styled.SummaryTitle>
      <Styled.ServicePlanSubText>
        {i18n['Applicable after the initial service term expiration. - EMEA']}
      </Styled.ServicePlanSubText>
      <Styled.ProposalSubscription
        $isMultipleScannerSubscriptions={isMultipleScannerSubscriptions}
      >
        <Styled.Head>
          <Styled.HeaderCell>{i18n['Product']}</Styled.HeaderCell>
          {isMultipleScannerSubscriptions && (
            <Styled.HeaderCell>{i18n['Related Scanner']}</Styled.HeaderCell>
          )}
          <Styled.HeaderCell>{i18n['Quantity']}</Styled.HeaderCell>
          <Styled.HeaderCell>{i18n['List Price']}</Styled.HeaderCell>
          <Styled.HeaderCell>
            {i18n['Total Promotion/Discount Amount']}
          </Styled.HeaderCell>
          <Styled.HeaderCell>{i18n['Total Price']}</Styled.HeaderCell>
        </Styled.Head>
        <Styled.BodyRows>
          {currentProposal.lineitems.map(item => (
            <React.Fragment key={item.name}>
              {item.subscriptions?.map(subscription => (
                <React.Fragment key={subscription.name}>
                  <Styled.BodyCell>
                    <Styled.BodyCellContent>
                      {subscription.name}
                      {subscription.servicePlan && (
                        <Styled.SubOptions>
                          <strong>
                            {i18n['Service Plan Fee Invoicing - EMEA']}:
                          </strong>{' '}
                          {subscription.servicePlan}
                        </Styled.SubOptions>
                      )}
                    </Styled.BodyCellContent>
                  </Styled.BodyCell>
                  {isMultipleScannerSubscriptions && (
                    <Styled.BodyCell>{item.name}</Styled.BodyCell>
                  )}
                  <Styled.BodyCell>{subscription.quantity}</Styled.BodyCell>
                  <Styled.BodyCell>
                    {subscription.displayItemUnitPrice}
                  </Styled.BodyCell>
                  <Styled.BodyCell>
                    {i18n['iTero Total Promotion Discount Table text - EMEA']}
                  </Styled.BodyCell>
                  <Styled.BodyCell>
                    {subscription.displayItemTotal}
                  </Styled.BodyCell>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </Styled.BodyRows>
      </Styled.ProposalSubscription>
    </>
  );
};

export default ServicePlanDetailsProposalEMEA;
